import { Landing } from "./pages/common/Landing";
import { Login } from "./pages/common/Login";
import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./App.css";
// Import axios config to set up global interceptor for token expiration handling
import "./utils/axiosConfig";
import { Home } from "./unused/Home";
import { BottomNavbar } from "./components/BottomNavbar";
import { Progress } from "./pages/Player/Progress";
import { User } from "./pages/common/Profile";
import Level from "./pages/Player/Level";
import CBLevel from "./pages/common/CBLevel";
// import { EditExercise } from "./pages/coach/EditExercise";
import { ExerciseDetail } from "./pages/coach/ExerciseDetail";
// import { CreateExercise } from "./pages/coach/CreateExercise";
import { CreateGroup } from "./pages/admin/CreateGroup";
import { Dashboard } from "./pages/admin/Dashboard";
import { Cart } from "./pages/Player/Cart";
import { Planning } from "./pages/Planning";
import { Training } from "./pages/Training";
import { ExerciseFeedback } from "./pages/coach/ExerciseFeedback";
import { CoachExerciseControl } from "./pages/coach/CoachExerciseControl";
import { FinalizedSessionResults } from "./pages/coach/FinalizedSessionResults";
import { Roles } from "./pages/superadmin/Roles";
import { Permissions } from "./pages/superadmin/Permissions";
import { Adminhome } from "./unused/AdminHome";
// import { Exercise } from "./pages/admin/Exercise";
import { Usermanagemnt } from "./pages/admin/Usermanagement";
import { ClubInquiries } from "./pages/admin/ClubInquiries";
import { Grouplist } from "./pages/admin/Grouplist";
import { TrainingSessionTemplates } from "./pages/admin/TrainingSessionTemplates";
import { CreateUser } from "./pages/admin/CreateUser";
import { EditProfile } from "./pages/common/EditProfile";
import Emailverify from "./pages/common/Emailverify";
import { ChangePassword } from "./pages/common/ChangePassword";
import { ChangeLng } from "./pages/common/ChangeLng";

// import { Createcomp } from "./pages/admin/Createcompentency";
// import { Competencylist } from "./pages/admin/Compentencylist";
import ProtectedRoute from "./Protectedroute/Protectedroute";
import CoachExerciseControlRoute from "./Protectedroute/CoachExerciseControlRoute";
import { Groupdetails } from "./pages/admin/Groupdetails";
import { EOut2 } from "./pages/Exerciseadd/Exercisesetup4";
import { Ein2 } from "./pages/Exerciseadd/Exercisesetup2";
import { E1 } from "./pages/Exerciseadd/Exercisesetup1";
import { PersonalizedTrainingSlot } from "./pages/Exerciseadd/PersonalizedTrainingSlot";
import { Eincb3 } from "./pages/Exerciseadd/Exercisesetup3";
import Wizardsession from "./pages/Exerciseadd/Wizardsession";
import { WCB3 } from "./pages/Exerciseadd/Wizardsetup3";
import { Changeex } from "./pages/Exerciseadd/Changeexercise";
import { ExerciseFeedbackP } from "./pages/Player/ExerciseFeedbackPage";
import { PlayerAutoevaluation } from "./pages/Player/PlayerAutoevaluation";
import { io } from "socket.io-client";
import { UpdateGroup } from "./pages/admin/UpdateGroup";
import UserAgreement from "./pages/admin/About Us/Useragreement";
import Terms from "./pages/admin/About Us/Terms";
import Alarm from "./components/Alarm";
import { AlarmProvider } from "./context/Alarmcontext";
import SequenceAlarm from "./components/SequenceAlarm";
import { SequenceAlarmProvider } from "./context/SequenceAlarmContext";
import { BrandProvider, useBrand } from "./context/BrandContext";
import { ClubLicenseProvider } from "./context/ClubLicenseContext";
import { MuiBrandTheme } from "./theme/MuiBrandTheme";
import AgreementUser from "./components/Useragreement";
import { UpdateUser } from "./pages/admin/UpdateUser";
import { SuperEditProfile } from "./pages/superadmin/EditProfile";
import { Club } from "./pages/superadmin/Club";
import { AddClub } from "./pages/superadmin/AddClub";
import { UpdateClub } from "./pages/superadmin/EditClub";
import { AddRole } from "./pages/superadmin/AddRoles";
import { EditRole } from "./pages/superadmin/EditRoles";
import { TourGuideEditor } from "./pages/superadmin/TourGuideEditor";
import { BusinessIntelligence } from "./pages/superadmin/BusinessIntelligence";
import { CaptureQosDashboard } from "./pages/superadmin/CaptureQosDashboard";
import { FixcodeDesk } from "./pages/superadmin/FixcodeDesk";
import TrainingSummaryRoute from "./pages/TrainingSummaryRoute";
import { PermissionsProvider } from "./context/Permissioncontext";
import { CompleteProfile } from "./pages/common/CompleteProfile";
import { Invite, InviteSignup } from "./pages/admin/Inviteuser";
import AIProfilingWizard from "./components/AIProfilingWizard";
import ClubAdminProfiling from "./components/ClubAdminProfiling";
import ParentProfilingWizard from "./components/ParentProfilingWizard";
import { trackScreenPath } from "./utils/screenAnalytics";
import ParentProgressHub from "./pages/parent/ParentProgressHub";
import ConfirmEmail from "./pages/ConfirmEmail";
import SetPassword from "./pages/SetPassword";
import RegistrationFlow from "./components/RegistrationFlow";
import PasswordRegistration from "./pages/PasswordRegistration";
import AICoachChat from "./components/AICoach/AICoachChat";
import { PingfloTourHost } from "./tour";
import { ExerciseManagement } from "./pages/admin/ExerciseManagement";
import { ExerciseForm } from "./pages/admin/ExerciseForm";
import { usePermissions } from "./context/Permissioncontext";
import BrandSettings from "./pages/admin/BrandSettings";
import ConsentLedgerPage from "./pages/admin/ConsentLedger";
import PrivacyNoticePage from "./pages/public/PrivacyNotice";
import TermsOfUsePage from "./pages/public/TermsOfUse";
import EulaPage from "./pages/public/Eula";
import TableRental from "./pages/admin/TableRental";
import BookLanding from "./pages/public/BookLanding";
import BookConfirmation from "./pages/public/BookConfirmation";
import DemoJoinPage from "./pages/public/DemoJoinPage";
import { NewcomerDossierPage } from "./pages/public/NewcomerDossierPage";
import TournamentInscriptionPage from "./pages/public/TournamentInscriptionPage";
import ClubJoinLanding from "./pages/public/ClubJoinLanding";
import MarketingHome from "./pages/public/MarketingHome";
import FlowStoryPage from "./pages/public/FlowStoryPage";
import PilotPage from "./pages/public/PilotPage";
import { isApexMarketingHost } from "./utils/isApexMarketingHost";
import { isSuperAdminUser } from "./utils/brandAuth";
import { canSeeDashboardBottomNav } from "./utils/homeRole";
import GoalProposals from "./pages/admin/GoalProposals";
import ExerciseProposals from "./pages/admin/ExerciseProposals";
import LevelBandMatrix from "./pages/admin/LevelBandMatrix";
import CompetitionsPage from "./pages/admin/CompetitionsPage";
import CompetitionPage from "./pages/common/CompetitionPage";
import PingfloNewsletterPage from "./pages/newsletter/PingfloNewsletterPage";
import PublicNewsletterPage from "./pages/newsletter/PublicNewsletterPage";
import { LiveTrainingPage } from "./pages/LiveTraining/LiveTrainingPage";
import ChampionshipMatchPage from "./pages/championship/ChampionshipMatchPage";
import ChampionshipPhoneVideosPage from "./pages/championship/ChampionshipPhoneVideosPage";
import ChampionshipClipAutoUpload from "./components/championship/ChampionshipClipAutoUpload";
import TacticalPatternLibrary from "./pages/tactical/TacticalPatternLibrary";
import MatchPrepScout from "./pages/tactical/MatchPrepScout";
import VoiceTestPage from "./pages/VoiceTest/VoiceTestPage";
import { PlayerPresenceConfirmDialog } from "./components/PlayerPresenceConfirmDialog";
import SwitchClubDialog from "./components/SwitchClubDialog";
import { getRouterBasename } from "./config";

function PermissionRoute({ permission, children }) {
  const { hasPermission } = usePermissions();
  const { t } = useTranslation();
  if (!hasPermission(permission)) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <h2>{t("access_denied")}</h2>
        <p>{t("no_permission")}</p>
      </div>
    );
  }
  return <>{children}</>;
}

function SuperAdminRoute({ children }) {
  const { t } = useTranslation();
  let user = {};
  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    user = {};
  }
  if (!isSuperAdminUser(user)) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <h2>{t("access_denied")}</h2>
        <p>{t("no_permission")}</p>
      </div>
    );
  }
  return <>{children}</>;
}

function DashboardStaffRoute({ children }) {
  let user = {};
  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    user = {};
  }
  if (!canSeeDashboardBottomNav(user)) {
    return <Navigate to="/home" replace />;
  }
  return <>{children}</>;
}

function HomeRoutePlaceholder() {
  return null;
}

function IndexRoute() {
  return isApexMarketingHost() ? <MarketingHome /> : <Landing />;
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    try {
      if (typeof localStorage !== "undefined" && localStorage.getItem("token")) {
        trackScreenPath(pathname);
      }
    } catch {
      /* ignore */
    }
  }, [pathname]);

  return null;
}

function AppShell() {
  const { brand } = useBrand();
  return (
    <ClubLicenseProvider initialLicense={brand?.club_license}>
      <MuiBrandTheme brand={brand}>
      <AlarmProvider>
      <SequenceAlarmProvider>
        <PermissionsProvider>
          <BrowserRouter basename={getRouterBasename()}>
            <ScrollToTop />
            <div data-testid="app-shell" style={{ display: "contents" }}>
            <Alarm />
            <SequenceAlarm />
            <AICoachChatWrapper />
            <PingfloTourHost />
            <PlayerPresenceConfirmDialog />
            <SwitchClubDialog />
            <ChampionshipClipAutoUpload />
          <Routes>
            <Route index element={<IndexRoute />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<RegistrationFlow />} />
            <Route path="/complete_profile" element={<CompleteProfile />} />
            <Route path="/profiling" element={<AIProfilingWizard />} />
            <Route path="/join/:clubCode/player" element={<AIProfilingWizard />} />
            <Route path="/join/:clubCode" element={<ClubJoinLanding />} />
            <Route path="/join" element={<ClubJoinLanding />} />
            <Route path="/club-admin-profiling" element={<ClubAdminProfiling />} />
            <Route path="/parent-profiling" element={<ParentProfilingWizard />} />
            <Route path="/confirm-email" element={<ConfirmEmail />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/password-registration" element={<PasswordRegistration />} />
            <Route path="/book/:clubCode" element={<BookLanding />} />
            <Route path="/book" element={<BookLanding />} />
            <Route path="/book/:clubCode/confirmation/:bookingId" element={<BookConfirmation />} />
            <Route path="/newsletter/public/:issueId" element={<PublicNewsletterPage />} />
            <Route path="/demo" element={<DemoJoinPage />} />
            <Route path="/newcomer/:token" element={<NewcomerDossierPage />} />
            <Route path="/tournament/:token" element={<TournamentInscriptionPage />} />
            <Route path="/flows/:flowId" element={<FlowStoryPage />} />
            <Route path="/pilot" element={<PilotPage />} />

            {/* Full-screen live training (no bottom nav) */}
            <Route
              path="/live-training"
              element={
                <ProtectedRoute>
                  <LiveTrainingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/competition/match/:matchId"
              element={
                <ProtectedRoute>
                  <ChampionshipMatchPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/competition/phone-videos"
              element={
                <ProtectedRoute>
                  <ChampionshipPhoneVideosPage />
                </ProtectedRoute>
              }
            />

            {/* Authenticated app: bottom bar on all protected screens */}
            <Route
              element={
                <ProtectedRoute>
                  <BottomNavbar />
                </ProtectedRoute>
              }
            >
              <Route path="/home" element={<HomeRoutePlaceholder />} />
              <Route path="/competition" element={<CompetitionPage />} />
              <Route path="/newsletter" element={<PingfloNewsletterPage />} />
              <Route path="/newsletter/:issueId" element={<PingfloNewsletterPage />} />
              <Route path="/tactical" element={<TacticalPatternLibrary />} />
              <Route path="/tactical/prep" element={<MatchPrepScout />} />
              <Route path="/planning" element={<Planning />} />
              <Route path="/training" element={<Training />} />
              <Route path="/progress" element={<Progress />} />
              <Route path="/parent/progress" element={<ParentProgressHub />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/profile" element={<User />} />
              <Route path="/voice-test" element={<VoiceTestPage />} />

              <Route path="/Wizardsession" element={<Wizardsession />} />
              <Route path="/SelectExerciseType" element={<E1 />} />
              <Route path="/PersonalizedTrainingSlot" element={<PersonalizedTrainingSlot />} />
              <Route path="/SelectTableExercises" element={<Ein2 />} />
              <Route path="/CompetencyBloc" element={<Eincb3 />} />
              <Route path="/Exerciseslist" element={<EOut2 />} />
              <Route path="/EditCBExercise" element={<WCB3 />} />
              <Route path="/Exercisedetail" element={<ExerciseDetail />} />
              <Route path="/ChangeExercise" element={<Changeex />} />

              <Route path="/Editprofile" element={<EditProfile />} />
              <Route path="/SuperAdminProfile" element={<SuperEditProfile />} />
              <Route path="/InviteUser" element={<InviteSignup />} />
              <Route path="/Club" element={<Club />} />
              <Route path="/BusinessIntelligence" element={<BusinessIntelligence />} />
              <Route path="/CaptureQos" element={<CaptureQosDashboard />} />
              <Route path="/Fixcode" element={<FixcodeDesk />} />
              <Route path="/AddClub" element={<AddClub />} />
              <Route path="/EditClub" element={<UpdateClub />} />
              <Route path="/Groupdetails" element={<Groupdetails />} />
              <Route path="/Level" element={<Level />} />
              <Route path="/YourCBLevel" element={<CBLevel />} />
              <Route path="/Training_Summary" element={<TrainingSummaryRoute />} />
              <Route path="/Exercise_feedback" element={<ExerciseFeedback />} />
              <Route
                path="/CoachExerciseControl"
                element={
                  <CoachExerciseControlRoute>
                    <CoachExerciseControl />
                  </CoachExerciseControlRoute>
                }
              />
              <Route
                path="/coach/session-results"
                element={<FinalizedSessionResults />}
              />
              <Route
                path="/Playerexercise_feedback"
                element={<ExerciseFeedbackP />}
              />
              <Route
                path="/player-autoevaluation"
                element={<PlayerAutoevaluation />}
              />

              <Route
                path="/Dashboard"
                element={
                  <DashboardStaffRoute>
                    <Dashboard />
                  </DashboardStaffRoute>
                }
              />
              <Route path="/Adminhome" element={<Adminhome />} />
              <Route path="/GroupList" element={<Grouplist />} />
              <Route
                path="/SessionTemplates"
                element={<TrainingSessionTemplates />}
              />
              <Route
                path="/ExerciseStudio"
                element={
                  <PermissionRoute permission="MANAGE_EXERCISES_STUDIO">
                    <ExerciseManagement />
                  </PermissionRoute>
                }
              />
              <Route
                path="/admin/exercise/new"
                element={
                  <PermissionRoute permission="MANAGE_EXERCISES_STUDIO">
                    <ExerciseForm />
                  </PermissionRoute>
                }
              />
              <Route
                path="/admin/exercise/edit/:ex_id"
                element={
                  <PermissionRoute permission="MANAGE_EXERCISES_STUDIO">
                    <ExerciseForm />
                  </PermissionRoute>
                }
              />
              <Route path="/UserManagement" element={<Usermanagemnt />} />
              <Route
                path="/ClubInquiries"
                element={
                  <SuperAdminRoute>
                    <ClubInquiries />
                  </SuperAdminRoute>
                }
              />
              <Route
                path="/TourGuide"
                element={
                  <SuperAdminRoute>
                    <TourGuideEditor />
                  </SuperAdminRoute>
                }
              />
              <Route path="/Consent" element={<ConsentLedgerPage />} />
              <Route path="/GoalProposals" element={<GoalProposals />} />
              <Route path="/ExerciseProposals" element={<ExerciseProposals />} />
              <Route path="/LevelClassification" element={<LevelBandMatrix />} />
              <Route path="/Competitions" element={<CompetitionsPage />} />
              <Route path="/Roles" element={<Roles />} />
              <Route path="/Add_Role" element={<AddRole />} />
              <Route path="/Edit_role" element={<EditRole />} />
              <Route path="/Permissions" element={<Permissions />} />
              <Route path="/GroupsAdd" element={<CreateGroup />} />
              <Route path="/EditGroup" element={<UpdateGroup />} />
              <Route path="/EditUser" element={<UpdateUser />} />
              <Route path="/User_Agreement" element={<UserAgreement />} />
              <Route path="/Termsofuse_Agreement" element={<Terms />} />
              <Route path="/UsersAdd" element={<CreateUser />} />
              <Route path="/ChangePassword" element={<ChangePassword />} />
              <Route path="/ChangeLanguage" element={<ChangeLng />} />
              <Route path="/BrandSettings" element={<BrandSettings />} />
              <Route path="/TableRental" element={<TableRental />} />
            </Route>

            <Route
              path="/PlayerHome"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route path="/Verify" element={<Emailverify />} />
            <Route path="/Termsofuse" element={<TermsOfUsePage />} />
            <Route path="/privacy" element={<PrivacyNoticePage />} />
            <Route path="/eula" element={<EulaPage />} />
            <Route path="/UserAgreement" element={<AgreementUser />} />
            {/* <Route path="/exercise/:exerciseId" element={<Exercise />} /> */}

            {/* <Route path="/exercise/add" element={<CreateExercise />} />
          <Route path="/exercise/edit/:exerciseId" element={<EditExercise />} />
          <Route path="/exercise/:Id" element={<CoachExercise />} /> */}

            {/* <Route
            path="/Competencybloc"
            element={
              <ProtectedRoute>
                <Competencylist />{" "}
              </ProtectedRoute>
            }
          /> */}

            {/* <Route
            path="/AddCompetencybloc"
            element={
              <ProtectedRoute>
                <Createcomp />{" "}
              </ProtectedRoute>
            }
          /> */}
            <Route path="*" element={<CatchAllRoute />} />
          </Routes>
            </div>
        </BrowserRouter>
      </PermissionsProvider>
      </SequenceAlarmProvider>
    </AlarmProvider>
    </MuiBrandTheme>
    </ClubLicenseProvider>
  );
}

function App() {
  return (
    <BrandProvider>
      <AppShell />
    </BrandProvider>
  );
}

/** Public / onboarding routes — DigiPing FAB must never appear here. */
const DIGIPING_PUBLIC_PATHS = [
  "/login",
  "/register",
  "/complete_profile",
  "/profiling",
  "/join",
  "/club-admin-profiling",
  "/parent-profiling",
  "/confirm-email",
  "/set-password",
  "/password-registration",
  "/book",
  "/newsletter/public",
  "/demo",
  "/flows",
  "/pilot",
  "/Verify",
  "/Termsofuse",
  "/privacy",
  "/eula",
  "/UserAgreement",
];

function isDigipingPublicPath(pathname) {
  const path = pathname || "/";
  if (path === "/") return true;
  return DIGIPING_PUBLIC_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

function hasLoggedInSession() {
  if (!localStorage.getItem("token")) return false;
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return Boolean(user?.user_id);
  } catch {
    return false;
  }
}

/** Unknown URLs: login if logged out, home if already signed in. */
function CatchAllRoute() {
  const location = useLocation();
  if (hasLoggedInSession()) {
    return <Navigate to="/home" replace />;
  }
  return <Navigate to="/login" replace state={{ from: location }} />;
}

/**
 * DigiPing icon only after login, never on landing / login / profiling / join.
 * On /live-training, Digiping is embedded in LiveTrainingFeedbackSheet.
 */
function AICoachChatWrapper() {
  const location = useLocation();
  const [loggedIn, setLoggedIn] = useState(() => hasLoggedInSession());

  useEffect(() => {
    const sync = () => setLoggedIn(hasLoggedInSession());
    sync();
    window.addEventListener("storage", sync);
    window.addEventListener("smarttt:auth-changed", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("smarttt:auth-changed", sync);
    };
  }, [location.pathname]);

  if (location.pathname === "/live-training") return null;
  if (location.pathname.startsWith("/competition/match")) return null;
  if (isDigipingPublicPath(location.pathname) || !loggedIn) return null;

  try {
    const brandConfig = JSON.parse(localStorage.getItem("brand_config") || "{}");
    if (brandConfig.show_ai_coach === false) return null;
  } catch {}

  return <AICoachChat />;
}

export default App;
